import axios from 'axios';
import { useState, useEffect } from 'react';
import { Input, Dialog } from 'react-weui-ts';
import { Handler, SCORE_STORE_KEY } from '../../common/handler';
import { doPostMessage } from '../../utils/rn';

interface SaveDialogProps {
    show: boolean;
    close: () => void;
    handler: Handler | null;
    title: string;
    id: string | null;
    onSuccess?: (data: any) => void;
}

const SaveDialog = ({ show, close, handler, title, id, onSuccess }: SaveDialogProps) => {
    const [name, setName] = useState(title);

    // 调试日志
    useEffect(() => {
        setName(title);
    }, [title]);

    const submitToApi = () => {
        const uuid = localStorage.getItem('uuid');
        const scoreData = handler?.getScoreData();
        const tone_pitch = localStorage.getItem('tone_pitch');

        doPostMessage(
            { id: uuid, score: scoreData, title: name, tone_pitch },
            'save-score'
        );
        close();
    };

    const buttons = [
        {
            label: '取消',
            onClick: () => {
                console.log('取消');
                close();
            },
            style: {
                color: '#666',
                background: '#F7F7F7',
                borderRadius: '10px',
                margin: '10px 15px 10px 15px',
            },
        },
        {
            label: '确定',
            onClick: () => {
                submitToApi();
            },
            style: {
                color: '#fff',
                background: '#DFAE4B',
                borderLeft: 'none',
                borderRadius: '10px',
                margin: '10px 15px 10px 15px',
            },
        },
    ];

    return (
        <Dialog type="ios" title={'乐谱名称'} buttons={buttons} show={show} className="save-dialog-custom">
            <Input
                style={{
                    border: '1px solid #DCDCDC',
                    padding: '10px',
                    width: 'calc(100% - 20px)',
                    borderRadius: '5px',
                    marginTop: '10px',
                    height: 40,
                }}
                value={name}
                onChange={(e: any) => {
                    setName(e.target.value);
                }}
                placeholder="请输入乐谱名字"
            />
        </Dialog>
    );
};

export default SaveDialog;
